export class AppSettings {
  public static locale = 'en-US';
}
